import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { PRICE_ANCHOR } from '../lib/config';

/** Barra fija inferior en mobile, visible a partir de los 600px de scroll. */
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-196" data-mp="3gl76c42q7jac">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.28,
      ease: [0.22, 1, 0.36, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-gold/30 bg-ink/95 px-4 py-3 backdrop-blur md:hidden" data-id="element-197" data-mp="3gkfkhkyxkzx9">
          <a href={PRICE_ANCHOR} className="group flex w-full items-center justify-center gap-2.5 rounded-card bg-gold-grad px-5 py-3.5 text-sm font-semibold text-ink focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/50" data-id="element-198" data-mp="gzk0en6yhjca">
            Quiero el sistema
            <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-199" data-mp="gxi7llplfaib" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}